<template>
  <el-dialog :title="dialogtitle" :visible.sync="dialog" :close-on-click-modal="false">
    <div>
      <el-form
        :model="storeForm"
        status-icon
        :rules="rules"
        ref="storeForm"
        label-width="100px"
        class="storeForm"
        :label-position="labelPosition"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <input
              type="password"
              name="fake-pwd"
              id="fake-pwd"
              style="position: absolute; opacity: 0; width: 0; height: 0"
            />
            <!-- <el-form-item label="门店编码" v-if="title == 'Tyd'" prop="storeNum">
            <el-input
              placeholder="请输入门店编码"
              type="text"
              v-model="storeForm.storeNum"
              autocomplete="off"
            >
            </el-input>
          </el-form-item> -->
            <el-form-item label="门店名称" prop="storeName">
              <el-input type="text" v-model="storeForm.storeName" autocomplete="off">
              </el-input>
            </el-form-item>
            <el-form-item label="省/市/区县" prop="region">
              <el-input v-model="storeForm.region" :disabled="true"> </el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="storeAddress">
              <el-input v-model="storeForm.storeAddress" autocomplete="off"></el-input>
              <el-button type="danger" size="mini" @click="dialogVisible = true">
                <i style="font-size: 20px" class="el-icon-location-information"></i>
              </el-button>
            </el-form-item>
            <!-- <el-form-item label="服务电话" v-if="title == 'Tyd'" prop="telephone">
            <el-input
              v-model="storeForm.telephone"
              autocomplete="off"
              oninput="this.value=this.value.replace(/[^\d]/g,'')"
              @blur="checkPhone('telephone')"
            >
            </el-input>
          </el-form-item> -->
            <el-form-item label="联系人" prop="contactName">
              <el-input
                v-model="storeForm.contactName"
                :name="`contactName_${seed}`"
                :id="`contactName_${seed}`"
                autocomplete="off"
              >
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="性别" prop="registrantSex">
            <el-radio-group v-model="storeForm.registrantSex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item> -->
            <el-form-item label="选择行业" v-if="title == 'Tyd'" prop="industry">
              <el-select v-model="storeForm.industry" filterable placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.num"
                  :label="item.name"
                  :value="item.num"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="推荐人" prop="reference" v-if="title == 'Smartrent'">
            <el-input placeholder="请输入推荐人" v-model="storeForm.reference"></el-input>
          </el-form-item> -->
          </el-col>
          <el-col :span="12">
            <input
              type="password"
              name="fake-pwd"
              id="fake-pwd"
              style="position: absolute; opacity: 0; width: 0; height: 0"
            />
            <el-form-item label="身份证号" prop="registrantIdentity">
              <el-input
                oninput="this.value=this.value.replace(/[\W]/g,'')"
                pattern="[0-9]*"
                v-model="storeForm.registrantIdentity"
                autocomplete="off"
                maxlength="18"
                :name="`idk_${seed}`"
                :id="`idk_${seed}`"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <!-- <input
            type="password"
            name="fake-pwd"
            id="fake-pwd"
            style="position: absolute; opacity: 0; width: 0; height: 0"
          /> -->
            <el-form-item label="手机号" prop="contactPhone">
              <el-input
                v-model="storeForm.contactPhone"
                autocomplete="off"
                maxlength="11"
                :name="`phone_${seed}`"
                :id="`phone_${seed}`"
                show-word-limit
                oninput="this.value=this.value.replace(/[^\d]/g,'')"
                @blur="checkPhone('contactPhone')"
              >
              </el-input>
            </el-form-item>
            <!-- <input
            type="password"
            name="fake-pwd"
            id="fake-pwd"
            style="position: absolute; opacity: 0; width: 0; height: 0"
          /> -->
            <el-form-item label="验证码" prop="code">
              <el-input
                ref="codeInput"
                v-model="storeForm.code"
                :name="`code_${seed}`"
                :id="`code_${seed}`"
                placeholder="请输入验证码"
              >
              </el-input>
              <el-button
                type="danger"
                plain
                @click="sendcode"
                :disabled="disabled"
                v-if="disabled == false"
                size="small"
              >
                发送验证码
              </el-button>
              <el-button
                type="danger"
                plain
                @click="sendcode"
                :disabled="disabled"
                size="mini"
                v-if="disabled == true"
              >
                {{ btntxt }}
              </el-button>
            </el-form-item>
            <el-form-item label="预设密码" prop="presupposePassword">
              <el-input
                type="password"
                v-model="storeForm.presupposePassword"
                show-password
                autocomplete="off"
                placeholder="用于首次登录"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkePassWord">
              <el-input
                type="password"
                v-model="storeForm.checkePassWord"
                autocomplete="off"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <!-- <el-form-item
            label="无业主进行出租"
            prop="isHasLandlord"
            v-if="title == 'Smartrent'"
          >
            <el-radio-group v-model="storeForm.isHasLandlord">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
          </el-form-item> -->
            <!-- <el-form-item label="门店描述" v-if="title == 'Tyd'" prop="description">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :autosize="{ minRows: 5, maxRows: 10 }"
              v-model="storeForm.description"
              maxlength="300"
              show-word-limit
              style="width: 200px"
            >
            </el-input>
          </el-form-item> -->
          </el-col>
        </el-row>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="danger" size="small" @click="cancel()" plain>取消</el-button>
          <el-button type="plain" size="small" @click="resetForm()">重置</el-button>
          <el-button
            type="success"
            size="small"
            v-if="title == 'Tyd'"
            @click="submitTyd()"
            plain
          >
            提交
          </el-button>
          <el-button
            type="success"
            size="small"
            v-if="title == 'Smartrent'"
            @click="submitSmartrent()"
            plain
          >
            提交
          </el-button>
        </div>
      </el-form>
      <!-- 地图弹出层 -->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="80%"
        :before-close="handleClose"
        :modal="false"
      >
        <div style="height: 51vh; overflow: auto">
          <BMap @getAddrByPoint="getAddrByPoint"></BMap>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" size="mini" @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="confirm((dialogVisible = false))"
            plain
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import BMap from "../baiduMap/BMap.vue";
import { addStore, getSmsCode } from "../../../api/api";
// import { getphonecode } from "../../../api/user.js";
export default {
  name: "baseStore",
  components: { BMap },
  props: {
    title: {
      type: String,
      default: "",
    },
    dialogtitle: {
      type: String,
      default: "",
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.storeForm.checkePassWord !== "") {
          this.$refs.storeForm.validateField("checkePassWord");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.storeForm.presupposePassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      seed: Date.now(),
      labelPosition: "right",
      dialogVisible: false,
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      location: "",
      keyword: "",
      myValue: "",
      storeForm: {
        // isHasLandlord: 1,
        // registrantSex: 1,
        industry: null,
        storeName: "",
        region: "",
        storeAddress: "",
        contactName: "",
        registrantIdentity: "",
        contactPhone: "",
        code: "",
        presupposePassword: "",
        checkePassWord: "",
        // description: "",
        province: "",
        city: "",
        county: "",
        locationLatitude: "",
        locationLongitude: "",
      },
      options: [],
      value: "",
      rules: {
        // storeNum: [
        //   {
        //     required: true,
        //     message: "请输入门店编码",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        storeName: [
          { required: true, message: "请输入门店名称", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        region: [{ required: true, message: "请选择地区", trigger: "change" }],
        storeAddress: [
          { required: true, message: "请输入详细地址", trigger: ["blur", "change"] },
        ],
        contactName: [{ required: true, message: "请填写联系人", trigger: "blur" }],
        registrantIdentity: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        // registrantSex: [{ required: true, message: "请选择性别", trigger: "change" }],
        contactPhone: [
          { required: true, message: "请输入您的手机号", trigger: ["blur", "change"] },
        ],
        code: [{ required: true, message: "请输入验证码!", trigger: "blur" }],
        // industry: [{ required: true, message: "请选择一个行业", trigger: "blur" }],
        presupposePassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "change",
          },
        ],
        checkePassWord: [{ required: true, validator: validatePass2, trigger: "change" }],
      },
      county: "",
      address: "",
      dialog: false,
    };
  },
  created() {},
  mounted() {
    // this.resetForm();
  },
  methods: {
    show() {
      this.dialog = true;
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    checkPhone(type) {
      var registrantMobilePhoneReg = /^1[3-9]\d{9}$/;
      var telephoneReg = /^0\d{2,3}-\d{7,8}(-\d{1,4})?$/;

      if (type == "contactPhone") {
        if (!registrantMobilePhoneReg.test(this.storeForm.contactPhone)) {
          // this.$message.warning("请输入正确的手机号");
        }
      } else if (type == "telephone") {
        if (!telephoneReg.test(this.storeForm.telephone)) {
          // this.$message.warning("请输入正确的服务电话");
        }
      }
    },
    getAddrByPoint(res) {
      this.county =
        res.addressComponents.province +
        "/" +
        res.addressComponents.city +
        "/" +
        res.addressComponents.district;
      // this.address = res.address
      this.address =
        res.addressComponents.street + "-" + res.addressComponents.streetNumber;
      this.storeForm.province = res.addressComponents.province;
      this.storeForm.city = res.addressComponents.city;
      this.storeForm.county = res.addressComponents.district;
      this.storeForm.locationLatitude = res.point.lat + "";
      this.storeForm.locationLongitude = res.point.lng + "";
    },
    confirm() {
      this.storeForm.region = this.county;
      this.storeForm.storeAddress = this.address;
    },
    cancel() {
      // this.$emit("dialogs", this.dialog);
      this.dialog = false;
      this.resetForm();
    },
    submitTyd() {
      const hasEmpty = Object.values(this.storeForm).some(
        (v) => v === null || v === undefined || v === ""
      );
      if (hasEmpty) {
        this.$alert("请填写完整信息", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return;
      }
      // delete this.storeForm.isHasLandlord;
      // delete this.storeForm.reference;
      // delete this.storeForm.region;
      delete this.storeForm.checkePassWord;
      if (this.$host == "http://192.168.1.10:3368") {
        var rawUrl = "http://192.168.1.171:8084/demay/ssm/store/officialWebsiteAddStore";
      } else {
        var rawUrl =
          "https://mall.decaisoft.com:8087/api/demay/ssm/store/officialWebsiteAddStore";
      }
      axios
        .post(rawUrl, this.storeForm)
        .then((res) => res.data)
        .then((res) => {
          if (res.code === "000000") {
            this.$alert("注册成功！", "提示", {
              confirmButtonText: "确定",
              type: "success",
              center: true,
              callback: () => this.cancel(),
            });
          } else {
            this.$alert(res.message || "注册失败", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              center: true,
            });
          }
        })
        .catch((err) => {
          this.$alert(err.message || "网络错误", "提示", {
            confirmButtonText: "确定",
            type: "error",
            center: true,
          });
        });
    },
    submitSmartrent() {
      // if (this.storeForm.industry == null) {
      //   this.storeForm.industry = 1;
      // }
      const hasEmpty = Object.values(this.storeForm).some(
        (v) => v === null || v === undefined || v === ""
      );
      if (hasEmpty) {
        this.$alert("请填写完整信息", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return;
      }
      // delete this.storeForm.region;
      delete this.storeForm.checkePassWord;
      if (this.$host == "http://192.168.1.10:3368") {
        var rawUrl = "http://192.168.1.171:8084/demay/ssm/store/officialWebsiteAddStore";
      } else {
        var rawUrl =
          "https://preview.decaisoft.com/api/demay/ssm/store/officialWebsiteAddStore";
      }
      axios
        .post(rawUrl, this.storeForm)
        .then((res) => res.data)
        .then((res) => {
          if (res.code === "000000") {
            this.$alert("注册成功！", "提示", {
              confirmButtonText: "确定",
              type: "success",
              center: true,
              callback: () => this.cancel(),
            });
          } else {
            this.$alert(res.message || "注册失败", "提示", {
              confirmButtonText: "确定",
              type: "warning",
              center: true,
            });
          }
        })
        .catch((err) => {
          this.$alert(err.message || "网络错误", "提示", {
            confirmButtonText: "确定",
            type: "error",
            center: true,
          });
        });
    },
    resetForm() {
      this.$refs.storeForm.resetFields();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleSelect(res) {
      //console.log"res", res);
      //console.logitem);
    },
    //发送验证码
    sendcode() {
      var that = this;
      // const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      const reg = /^1[3-9]\d{9}$/;
      if (this.storeForm.contactPhone == "") {
        that.$message({
          message: "手机号不能为空",
          center: true,
        });
        return;
      }
      if (!reg.test(that.storeForm.contactPhone)) {
        that.$message({
          message: "手机号格式不对！",
          center: true,
        });
        return;
      } else {
        if (this.$host == "http://192.168.1.10:3368") {
          var rawUrl = "http://192.168.1.171:8084/demay/ssm/login/getSmsCode";
        } else {
          if (that.title == "Smartrent") {
            var rawUrl = "https://preview.decaisoft.com/api/demay/ssm/login/getSmsCode";
          } else if (that.title == "Tyd") {
            var rawUrl = "https://mall.decaisoft.com:8087/api/demay/ssm/login/getSmsCode";
          }
        }
        axios
          .post(rawUrl, { phone: that.storeForm.contactPhone, getType: 2 })
          .then((res) => res.data)
          .then((res) => {
            if (res.code == "000000") {
              that.$message.success({ message: res.message });
              that.time = 60;
              that.disabled = true;
              that.timer();
              that.$nextTick(() => {
                that.$refs.codeInput.focus();
              });
            } else {
              that.$message.error({ message: res.message });
            }
          })
          .catch((err) => {
            this.$alert(err.message || "网络错误", "提示", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          });
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
  },
  watch: {
    title: {
      immediate: true,
      handler(newVal) {
        if (newVal === "Smartrent") {
          this.options = [
            { num: 1, name: "美容" },
            { num: 2, name: "美发" },
            { num: 3, name: "美容美发" },
            { num: 4, name: "物业公司" },
            { num: 5, name: "其他" },
          ];
          delete this.storeForm.industry;
          delete this.rules.industry;
        } else if (newVal === "Tyd") {
          this.options = [
            { num: 1, name: "美容" },
            { num: 2, name: "美发" },
            { num: 3, name: "美容美发" },
          ];
          this.rules.industry = [
            { required: true, message: "请选择一个行业", trigger: "change" },
          ];
        }
      },
    },
  },
};
</script>

<style scoped>
.storeForm {
  padding: 30px 50px;
}
.storeForm .el-input {
  width: 200px;
}
.map {
  height: 45px;
  width: 260px;
}
.maxMap {
  height: 500px;
  width: 100%;
}
.el-icon-location-information {
  color: white !important;
}

.el-icon-arrow-right .el-cascader-node__postfix {
  color: black !important;
}
.el-cascader {
  width: 260px;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #f78989;
}
</style>



// WEBPACK FOOTER //
// src/components/common/baseStore/baseStore.vue